import React, { useEffect, useState } from 'react';

const LoadingComponent = ({show}:any) => {
  useEffect(() => {
    document.body.style.cursor = show ? "progress" :  'default';
  }, [show]);

  return (
    <div className="loading" style={{'display': show ? 'block' : 'none'}}>
      <div className="spinner-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    </div>
  );
}

export default LoadingComponent;